import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Dropdown, DropdownButton, Button, Modal } from 'react-bootstrap';
import { addToCartFavoriteOffers } from '../../../../actions/favorites';
import notifier from '../../../../../_utils/notifier';
import { YANDEX } from '../../../../../config';
import { createPayment } from '../../../../actions/cart';
import { ThreeDots } from '../../../common/Placeholders.jsx';
import PaypalWidgetComponent from '../../../Payments/PaypalPaymentForm.jsx';
import YandexWidgetComponent from '../../../Payments/YandexPaymentForm.jsx';


const BuyButton = ({id, name, price_format, discount_price, discount, payment_service,
                     addToCartFavoriteOffers, createPayment}) => {
  let [paymentError, setPaymentError] = useState(null);
  let [payment, setPayment] = useState(null);
  let [buyButtonDisabled, setBuyButtonDisabled] = useState(false);
  let [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleBuyClick = async () => {
    handleShow();
    const response = await createPayment(id);
    if ('id' in response){
      setPayment(response);
    } else {
      setPaymentError(response);
    }
   };

  const handleBuyApprove = () => {
    setBuyButtonDisabled(true);
    setShow(false);
  }

  const handleCartClick = async (event) => {
    event.currentTarget.setAttribute('disabled', 'disabled');
    let response = await addToCartFavoriteOffers([id]);
    if (response) notifier.success(gettext('Аранжировка успешно добавлена в корзину'));
  };

  const buttonTitle = <span><i className='icon icon-floppy'></i>{' '}
    { gettext('Скачать') } ({ discount_price })
  </span>;

  let modal_price = '';
  if (discount){
    modal_price = <>
      <span className="card-price__without-discount mr-2">{ price_format }</span>
      <span className="card-price__with-discount">{ discount_price }</span>
    </>;
  } else {
    modal_price = price_format;
  }

  let widget = <ThreeDots/>;
  if (paymentError){
    widget = <div className={'alert alert-info'}>{ paymentError }</div>
  }
  if (payment){
    if (payment_service == YANDEX){
      widget = <YandexWidgetComponent offer={name}
                                      payment={payment}
                                      onBuyApprove={handleBuyApprove}/>
    } else {
      widget = <PaypalWidgetComponent offer={name}
                                      payment={payment}
                                      onBuyApprove={handleBuyApprove}/>
    }
  }

  return(
    <>
        <DropdownButton title={ buttonTitle }
                        variant='outline-dark'
                        size='sm'
                        className={'white-space-nowrap'}>
          <Dropdown.Item as="button" onClick={ handleBuyClick } disabled={ buyButtonDisabled }>
            { gettext('Купить сразу') }
          </Dropdown.Item>
          <Dropdown.Item as="button" onClick={ handleCartClick }>
            { gettext('Добавить в корзину') }
          </Dropdown.Item>
        </DropdownButton>

        <Modal show={ show } onHide={ handleClose } size='md'>
          <Modal.Header closeButton>
            <Modal.Title>
              { name }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className={'font-weight-bold'}>{ gettext('Цена') }: { modal_price }</p>
            <p>{ gettext('После прохождения оплаты файлы будут высланы вам на электронный адрес указаный при регистрации.') }</p>
            <p>{ gettext('Также, файлы всегда будут доступны для скачивания в разделе "Моя коллекция" личного кабинета.') }</p>
            { widget }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={ handleClose }>
              { gettext('Закрыть') }
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
}

BuyButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  price_format: PropTypes.string.isRequired,
  discount_price: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
  payment_service: PropTypes.string.isRequired,
  addToCartFavoriteOffers: PropTypes.func.isRequired,
  createPayment: PropTypes.func.isRequired,
}


export default compose(
  connect(null, { addToCartFavoriteOffers, createPayment }),
)(BuyButton);